import Vue from "vue";
import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library
Vue.use(VueEasytable);
